export default "__VITE_ASSET__3Gr82Hgm__"